import {
    type DeleteUserResponseType,
    type DeleteUserRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteUser = async (params: DeleteUserRequestType): Promise<DeleteUserResponseType> => {
    return await request<DeleteUserResponseType>("/user/deleteUser", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default DeleteUser;
